module.exports = __webpack_public_path__ + "static/media/press-tc-disrupt@3x.98ad721a.jpg";